import React from "react";
import { useTranslation } from "react-i18next";
import { FloatButton } from "antd";

import PCTemplate from "../../components/pc-template";
import Footer from "../../components/footer";
import SeoHead from "../../components/seoHead";
import Header from "../../components/header";
import { useAppLocale } from "../../i18n/LocaleRouting";
import {
  SITE_LOGO_URL,
  SITE_NAME,
  SITE_URL,
  absoluteLocalizedUrl,
  schemaInLanguage,
} from "../../i18n/seoUrls";

const Home: React.FC = () => {
  const { t } = useTranslation();
  const locale = useAppLocale();
  const homeUrl = absoluteLocalizedUrl("/", locale);

  return (
    <>
      <SeoHead
        title={t("seo.home.title")}
        description={t("seo.home.description")}
        path="/"
        keywords={t("seo.home.keywords")}
        structuredData={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: SITE_NAME,
            url: homeUrl,
            inLanguage: schemaInLanguage(locale),
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: SITE_NAME,
            url: SITE_URL + "/",
            logo: SITE_LOGO_URL,
          },
        ]}
      />
      <Header />
      <PCTemplate />
      <Footer />

      <FloatButton.BackTop />
    </>
  );
};

export default Home;
